<template>
  <v-text-field
    id="alert-description"
    aria-label="alert-description"
    v-model="alertDescription"
    class="mb-0"
    clearable
    required
    :rules="requiredRule"
    :placeholder="$t('admin.alerts.new.description')">
  </v-text-field>
</template>

<script>
  import { SET_ALERT_DESCRIPTION, SET_ALERT_DETAILS_DESCRIPTION } from '../../../store/mutation-types'
  import { EDIT_ALERT_DETAILS } from '../../../store/action-types'

  export default {
    name: 'alertDescription',
    data () {
      return {
        requiredRule: [v => !!v || this.$t('field_required'), v => (v && !this.nameExists(v)) || this.$t('admin.alerts.new.must_be_unique')]
      }
    },
    computed: {
      alerts () {
        return this.$store.state.admin.newAlerts
      },
      currentAlert () {
        return this.$store.state.admin.newSingleAlert
      },
      displayFlag () {
        return this.$store.state.admin.alertDetailsDisplayFlag
      },
      alertDescription: {
        get () {
          return this.$store.state.admin.newSingleAlert.name
        },
        set (value) {
          if (value && !this.nameExists(value)) {
            this.$store.commit(SET_ALERT_DETAILS_DESCRIPTION, value)
            if (this.displayFlag) {
              this.$store.commit(SET_ALERT_DESCRIPTION, {alertId: this.currentAlert.id, description: value})
              this.$store.dispatch(EDIT_ALERT_DETAILS, {alert: this.$store.state.admin.newSingleAlert})
            }
          }
        }
      }
    },
    methods: {
      nameExists (value) {
        return this.alerts.filter(el => el.id !== this.currentAlert.id && !el.isHidden).map(el => el.description.toLowerCase()).includes(value.toLowerCase())
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/settings/alert/alertDescription.vue